import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const ExpandIcon = () => <FontAwesomeIcon icon={["fas", "expand"]}/>

export default ExpandIcon;